export { default as authMiddleware } from '@/modules/auth/auth.middleware.js';
export { default as validateMiddleware } from '@/shared/utils/middlewares/validate.middleware.js';
export { default as uploadMiddleware } from '@/shared/utils/middlewares/upload.middleware.js';
export * as errorMiddleware from '@/shared/utils/middlewares/error.middleware.js';
